export const mapEmployeeProjectsDto = (dto) => ({
    id: dto.id,
    userId: dto.user_id,
    title: dto.title,
    industry: dto.industry,
    startDate: dto.start_date,
    endDate: dto.end_date,
    skills: dto.skills,
    description: dto.description,
    sortOrder: dto.sort_order,
});
